import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Loading } from '../../../../../../../common/loading'
import { selectLoading } from '../../../../store/slice'
import { getHistoricalChangeDrdDataThunk } from '../../../../store/thunk'

export const RiskComponentAnalysisTime = ({
  children,
  isFetchAPI,
  isShowLoading,
}) => {
  const location = useLocation()
  const dispatch = useDispatch()

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const isLoading = useSelector(selectLoading('listFilterTimeHistoricalChange'))

  useEffect(() => {
    if (isFetchAPI) {
      dispatch(
        getHistoricalChangeDrdDataThunk({
          OrganizationId: params.organizationId,
        }),
      )
    }
  }, [params.organizationId])

  if (isLoading && isShowLoading) {
    return (
      <div className="positionRelative h100">
        <Loading />
      </div>
    )
  }

  return children
}

RiskComponentAnalysisTime.propTypes = {
  children: PropTypes.node.isRequired,
  isFetchAPI: PropTypes.bool,
  isShowLoading: PropTypes.bool,
}

RiskComponentAnalysisTime.defaultProps = {
  isFetchAPI: true,
  isShowLoading: true,
}
